import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';

import FavoriteButton, { FavoriteButtonType } from '../FavoriteButton';
import Rating from '../Rating';
import BonusProgram from './BonusProgram';

import type { ProviderWithArrayIndex } from 'Provider-Types';

import useTextParser from 'favoriteList/hooks/useTextParser';
import styles from './providerHeader.module.scss';

type Props = {
  provider: ProviderWithArrayIndex;
  handleProviderFavoriteButtonClick: (provider: ProviderWithArrayIndex) => void;
  isDomestic: boolean;
};

const ProviderHeader = ({ provider, handleProviderFavoriteButtonClick, isDomestic }: Props) => {
  const { detailAreaName, hotelInfoUrl, hotelName, ratingInfo, tags } = provider;
  const { count, average } = ratingInfo;
  const isBonusProgram = tags && tags.bonusProgram;
  const textParser = useTextParser({
    originalText: hotelName,
  });
  const formattedHotelName = textParser.formattedText;

  const deviceType = useDeviceType();
  const isSP = deviceType === MOBILE_SCREEN;

  return (
    <div className={styles.container}>
      <div className={styles.providerTitleRow}>
        <div className={styles.providerTitleBox}>
          {hotelName && (
            <div className={styles.providerTitleContainer}>
              <div className={styles.providerTitleContent}>
                {isBonusProgram && <BonusProgram />}
                <h2 data-testid="providerHeader-primary-name" className={styles.title}>
                  <a className={styles.link} href={hotelInfoUrl}>
                    {formattedHotelName}
                  </a>
                </h2>
              </div>
              <div className={styles.favoriteButton}>
                <FavoriteButton
                  type={FavoriteButtonType.PROVIDER}
                  provider={provider}
                  handleProviderFavoriteButtonClick={handleProviderFavoriteButtonClick}
                  isDomestic={isDomestic}
                />
              </div>
            </div>
          )}
          {detailAreaName && (
            <h3 className={styles.providerArea} data-testid="providerHeader-secondary-area">
              {detailAreaName}
            </h3>
          )}
        </div>
        {ratingInfo.average > 0 && (
          <div className={styles.providerRating}>
            <Rating rating={average} numReviews={count} type={isSP ? 'SP' : 'PC'} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProviderHeader;
